export enum InhibitorType {
    PTBC = 1, // 'PTBC (para-tertiary butyl catechol)'
    HQ = 2, // 'HQ (hydroquinone)'
    MEHQ = 3, // 'MEHQ (hydroquinone monomethyl ether)'
    BHT = 4, // 'BHT (butylated hydroxy toluene)'
    PTZ = 5, // 'PTZ (Phenothiazine)'
    TOPANOL = 6, // 'TOPANOL (topanol antioxidant)'
}

export const InhibitorTypeNames: Record<InhibitorType, string> = {
    [InhibitorType.PTBC]: 'PTBC (para-tertiary butyl catechol)',
    [InhibitorType.HQ]: 'HQ (hydroquinone)',
    [InhibitorType.MEHQ]: 'MEHQ (hydroquinone monomethyl ether)',
    [InhibitorType.BHT]: 'BHT (butylated hydroxy toluene)',
    [InhibitorType.PTZ]: 'PTZ (Phenothiazine)',
    [InhibitorType.TOPANOL]: 'Topanol',
};

export const getInhibitorType = (inhibitorTypeId: number): InhibitorType => {
    return inhibitorTypeId as InhibitorType;
};

export const getInhibitorTypeId = (inhibitorType: InhibitorType): number => {
    return inhibitorType as number;
};

export const getInhibitorTypeName = (inhibitorType: InhibitorType): string => {
    return InhibitorTypeNames[inhibitorType];
};
